import { defineStore } from 'pinia'
import { isProxy, toRaw } from "vue";

export const useModalStore = defineStore('modal',{
  state: () => {
    return {
      modals: [],
    }
  },
  actions: {
    open(component, props = {}) {
      return new Promise((resolve, reject) => {
        document.getElementsByTagName('body')[0].classList.add('modal-open')
        this.modals.push({
          component,
          props,
          close: value => {
            const index = this.modals.findIndex((item) => {
              return toRaw(item.component) == (isProxy(component) ? toRaw(component) :  component)
            })
            if(index != -1) {
              this.modals.splice(index, 1)
            }
            if(this.modals.length === 0){
              document.getElementsByTagName('body')[0].classList.remove('modal-open')
            }
            resolve(value);
          },
          dismiss: reason => {
            const index = this.modals.findIndex((item) => {
              return toRaw(item.component) == (isProxy(component) ? toRaw(component) :  component)
            })
            if(index != -1) {
              this.modals.splice(index, 1)
            }
            if(this.modals.length === 0){
              document.getElementsByTagName('body')[0].classList.remove('modal-open')
            }
            reject(reason);
          },
        });
      });
    },
  },
  strict: false,
})
